<template>
  <div>
    <Sidebar />
    <div class="content-wrapper desktop-wrapper">
      <Toolbar />
      <router-view />
    </div>
    <div class="platform-info" v-if="showAlert && canMigrateToV2">
      <span class="to-left alert-text-info">
        <img src="../assets/icons/info.png" class="info-alert-image"  width="20"/>
        Uma nova versão da plataforma Yup Chat está disponível, com recursos e melhorias incríveis! Gostaria de migrar para a nova versão e aproveitar todas as novidades?
      </span>
      <a
        class="to-left btn-info-alert"
        href="http://localhost:8000"
        :class="{ disabled: bridgeLoading }"
        @click.prevent="goToV2"
      >
        Atualizar versão
      </a>
      <span class="to-right">
        <i class="fa fa-times close-alert-info c-pointer" @click="showAlert = false"></i>
      </span>
      <div style="clear: both;"></div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from '@/plugins/axios';
import Swal from 'sweetalert2';
import Sidebar from '@/components/menu/Sidebar.vue';
import Toolbar from '@/components/menu/Toolbar.vue';

export default {
  name: 'Layout',
  data() {
    return {
      showAlert: true,
      bridgeLoading: false,
    };
  },
  components: {
    Sidebar,
    Toolbar,
  },
  computed: {
    canMigrateToV2() {
      const { role } = this.$store.state.account;
      // return role === 'owner' && this.$store.state.account.whitelabel_id === null;
      return role === 'owner' && (this.$store.state.account.whitelabel_id === null || this.$store.state.account.whitelabel_id === '397c00a1-9730-4171-aa2c-b3d8cf9c3f83');
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
    setInterval(() => {
      this.$live.checkStatus();
    }, 15000);
  },
  methods: {
    handleScroll() {
      const toolbar = document.querySelector('.navbar-desktop');

      if (toolbar) {
        const top = document.body.getBoundingClientRect().top;
        toolbar.classList.add('navbar-desktop-active', top < 0);
      }
    },
    async goToV2() {
      const { isConfirmed } = await Swal.fire({
        title: 'Migrar para a nova versão?',
        text: 'Ao prosseguir, todos os usuários da conta serão redirecionados para a nova versão da plataforma.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, migrar',
        cancelButtonText: 'Cancelar',
      });

      if (!isConfirmed) return;

      this.bridgeLoading = true;
      try {
        const { data } = await axios().post('auth/v2-login');
        window.location.href = `${data.redirect_url}`;
      } finally {
        this.bridgeLoading = false;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.content {
  /*height: calc(100vh - 65px);*/
  /*overflow-y: scroll;*/
  /*left: 65px;*/
}
.v-align-top{
  vertical-align: top !important;
}
.sidebar-content-custom{
  overflow-y: hidden !important;
}
.second-toolbar a{
  visibility: hidden !important;
}
.platform-info {
  height: 48px;
  background: #EFF2F9;
  position: fixed;
  bottom: 0px;
  width: 100%;
  padding: 10px;
}
.close-alert-info {
  color: #2163DE;
}
.close-alert-info:hover {
  color: #1851b9;
}
.alert-text-info {
  color: #2163DE;
  font-weight: 400;
  font-size: 14px;
}
.info-alert-image {
  margin-right: 10px;
}
.btn-info-alert {
  background: #285EFA29;
  border: none;
  padding: 8px;
  font-size: 11px;
  border-radius: 15px;
  color: #2163DE;
  font-weight: 700;
  float: right;
  margin-left: 20px;
  margin-top: -2px;
}
.btn-info-alert:hover {
  background: #01030836 !important;
}
</style>
